import { Component, OnInit } from '@angular/core';
import { TokenProviderService } from 'src/app/api';
import { startWith } from 'rxjs/operators';
import { TutorialApiService } from '../../services/api/tutorial-api.service';
import { TutorialButtonRef } from '../tutorial-button-ref';
import { TutorialPanelComponent } from '../tutorial-panel/tutorial-panel.component';
import { TutorialService } from '../tutorial.service';

@Component({
  selector: 'mandae-tutorial',
  template: '',
  styles: []
})
export class TutorialComponent implements OnInit {

  private buttonRef: TutorialButtonRef = null;
  private panel: TutorialPanelComponent = null;

  constructor(
    private tutorial: TutorialService,
    private tutorialApi: TutorialApiService,
    private tokenProvider: TokenProviderService,
  ) { }

  public ngOnInit(): void {
    this.tokenProvider.user
      .pipe(startWith(this.tokenProvider.currentUser))
      .subscribe(user => {
        if (!user) {
          this.uninstall();
        } else {
          this.install();
        }
      });
  }

  private install() {
    if (this.buttonRef) {
      return;
    }

    this.tutorialApi.getTutorialCompletion()
      .subscribe(status => {
        if (status.finalizado) {
          return;
        }

        [ this.buttonRef, this.panel ] = this.tutorial.showButton(TutorialPanelComponent, {
          buttonText: 'PRIMEIROS PASSOS',
          completionStatus: status,
        });
      });
  }

  private uninstall() {
    if (!this.buttonRef) {
      return;
    }

    this.buttonRef.close();
    this.buttonRef = null;
  }

}
